<template>
  <div class="sticker-detail-wrap">
    <el-card class="mb20">
      <div slot="header">
        <span>溯源码详情</span>
      </div>
      <div class="base-info">
        <table width="100%" class="sticker-detail-table" cellpadding="0" cellspacing="0">
          <tr>
            <th>溯源码</th>
            <td>{{ detailData.traceable_code }}</td>
            <th>防伪码</th>
            <td>{{ detailData.security_code }}</td>
          </tr>
          <tr>
            <th>批次名</th>
            <td>{{ detailData.sticker_log_info?detailData.sticker_log_info.batch_name:'' }}</td>
            <th>仓库id</th>
            <td>{{ detailData.warehouse_id }}</td>
          </tr>
          <tr>
            <th>gid</th>
            <td>{{ detailData.activations?detailData.activations.goods_id:'' }}</td>
            <th>商品名</th>
            <td>{{ detailData.goods_info?detailData.goods_info.name:'' }}</td>
          </tr>
          <tr>
            <th>品牌id</th>
            <td>{{ detailData.goods_info?detailData.goods_info.brand_id:'' }}</td>
            <th>品牌名</th>
            <td>{{ detailData.goods_info?detailData.goods_info.brand_name:'' }}</td>
          </tr>
          <tr>
            <th>最低零售价</th>
            <td>{{ detailData.goods_info?detailData.goods_info.price:'' }}</td>
            <th>积分值</th>
            <td>
              <span class="mr10">{{ detailData.score }}</span>
              <el-button
                type="primary"
                size="mini"
                @click="toEditScore"
                v-if="detailData.status == 2"
              >修改</el-button>
            </td>
          </tr>
          <tr>
            <th>发货单号</th>
            <td>{{ detailData.order_id }}</td>
            <th>出库单号</th>
            <td>{{ detailData.outer_id }}</td>
          </tr>
          <tr>
            <th>
              订单编号
            </th>
            <td>
              {{ detailData.sub_oid ? detailData.sub_oid : '-'}}
            </td>
            <th>店铺id</th>
            <td>{{ detailData.shop_info?detailData.shop_info.id:'' }}</td>

          </tr>
          <tr>
            <th>店铺名</th>
            <td>{{ detailData.shop_info?detailData.shop_info.name:'' }}</td>
            <th>店铺联系人手机</th>
            <td>{{ detailData.shop_info?detailData.shop_info.contacts_mobile:'' }}</td>
          </tr>
          <tr>
            <th>用户id</th>
            <td>
              <span
                @click="toUserDetail(detailData.user_info.ac_id)"
                class="cursor underline"
                v-if="detailData.user_info"
              >{{ detailData.user_info.ac_id }}</span>
            </td>
            <th>初始地址</th>
            <td>{{ detailData.shop_info?detailData.shop_info.address:'' }}</td>
          </tr>
          <tr>
            <th>生成时间</th>
            <td>{{ detailData.created_at }}</td>
            <th>首次被查询时间</th>
            <td>{{ detailData.used_at }}</td>
          </tr>
          <tr>
            <th>状态</th>
            <td>
              <span v-if="detailData.status == 1">
                <span class="mr10">待激活</span>
                <el-button type="primary" size="mini" @click="delSticker">作废</el-button>
              </span>
              <span v-if="detailData.status == 2">已激活</span>
              <span v-if="detailData.status == 3">已使用</span>
              <span v-if="detailData.status == 4">已作废</span>
            </td>
            <th>出库绑定商品时间</th>
            <td>{{ detailData.activated_at }}</td>
          </tr>
            <tr>
                <th>领用单号</th>
                    <td>{{ detailData.recipients_number ? detailData.recipients_number : '' }}</td>
                <th>出库收货人地址</th>
                <td>
                    <span v-if="detailData.receiver && Object.keys(detailData.receiver).length > 0">
                        {{ detailData.receiver.receiver_province }}
                        {{ detailData.receiver.receiver_city }}
                        {{ detailData.receiver.receiver_area }}
                        {{ detailData.receiver.receiver_address }}
                    </span>
                </td>
            </tr>
            <tr>
                <th>出库收货人姓名</th>
                <td>
                    {{ detailData.receiver && detailData.receiver.receiver_name ? detailData.receiver.receiver_name : '' }}
                </td>
                <th>出库收货人电话</th>
                <td>
                    {{ detailData.receiver && detailData.receiver.receiver_phone ? detailData.receiver.receiver_phone : '' }}
                </td>
            </tr>
        </table>
      </div>
    </el-card>
    <el-card>
      <div slot="header">
        <span>查询记录</span>
      </div>
      <div class="detail-list">
        <el-table border :data="dataList" header-row-class-name="table-black-header">
          <el-table-column label="用户id" prop="ac_id">
            <template slot-scope="scope">
              <span
                @click="toUserDetail(scope.row.ac_id)"
                class="cursor underline"
              >{{ scope.row.ac_id }}</span>
            </template>
          </el-table-column>
          <el-table-column label="查询IP" prop="query_ip"></el-table-column>
          <el-table-column label="所属地区" prop="ip_address"></el-table-column>
          <el-table-column label="查询时间" prop="queried_at"></el-table-column>
          <el-table-column label="第几次查询" prop="num"></el-table-column>
        </el-table>
        <!--页码信息-->
        <div class="ftc mt20">
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :total="page.total"
            :page-size="page.pageSize"
            @current-change="currentPageChange"
          ></el-pagination>
        </div>
      </div>

      <!-- 修改积分对话框 -->
      <el-dialog
        title="修改积分"
        :visible.sync="editScoreDialog.showDialog"
        :before-close="closeEditScoreDialog"
        custom-class="opera-dialog"
      >
        <el-input v-model="editScoreDialog.score" place-holder="请输入积分" @keyup.native="checkScore"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="confirmEditScore">确 定</el-button>
          <el-button size="small" @click="closeEditScoreDialog">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { stickerApi } from "@/api/sticker";
export default {
  data() {
    return {
      id: "",
      detailData: "",
      dataList: [],
      showEditScore: false,
      page: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      editScoreDialog: {
        showDialog: false,
        score: ""
      }
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    /**
     * 初始化
     */
    initData() {
      this.id = this.$route.params.id;
      this.getDetailInfo();
    },
    /**
     * 获取贴纸详情
     */
    getDetailInfo() {
      let pam = this.id + "_" + this.page.currentPage;
      this.$EpetJs.Common.get(stickerApi.newStickerListUrl + "/" + pam).then(
        res => {
          if (res) {
            this.detailData = res.data.data;
            if (res.data.data.security_code) {
              this.getRecordList();
            }
          }
        }
      );
    },
    /**
     * 获取查询记录
     */
    getRecordList() {
      const pam = {
        page: this.page.currentPage,
        per_page: this.page.pageSize
      };
      this.$EpetJs.Common.get(
        stickerApi.getStickerRecordsUrl + "/" + this.detailData.traceable_code,
        pam
      ).then(res => {
        if (res) {
          this.dataList = res.data.data;
          if (res.data.meta && res.data.meta.pagination) {
            this.page.total = res.data.meta.pagination.total;
          }
        }
      });
    },
    /**
     * 当前页改变
     */
    currentPageChange(val) {
      this.page.currentPage = val;
      this.getRecordList();
    },
    /**
     * 删除贴纸
     */
    delSticker() {
      this.$EpetJs.Common.confirm("是否确认作废该贴纸?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$EpetJs.Common.patch(
            stickerApi.getStickerListUrl + "/" + this.id
          ).then(res => {
            if (res) {
              this.$message.success("作废成功！");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    /**
     * 显示编辑积分对话框
     */
    toEditScore() {
      this.editScoreDialog.showDialog = true;
      this.editScoreDialog.score = this.detailData.score;
    },
    /**
     * 检测变动数量
     */
    checkScore() {
      let value = this.editScoreDialog.score;
      value = value.replace(/[^\d]/g, "");
      // value = value.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
      // value = value.replace("-","$#$").replace(/\-/g,"").replace("$#$","-");
      // value = value.replace(/^(\-)*(0)*(\d+)*$/,'$1$3');
      this.editScoreDialog.score = value;
    },
    /**
     * 确认编辑积分
     * @returns {boolean}
     */
    confirmEditScore() {
      if (this.editScoreDialog.score == "") {
        this.$message.warning("请输入积分！");
        return false;
      }
      const pam = {
        score: this.editScoreDialog.score
      };
      this.$EpetJs.Common.patch(
        stickerApi.editScoreUrl + "/" + this.id,
        pam
      ).then(res => {
        if (res) {
          this.$message.success("设置成功！");
          this.closeEditScoreDialog();
          this.getDetailInfo();
        }
      });
    },
    /**
     * 关闭积分编辑对话框
     */
    closeEditScoreDialog() {
      this.editScoreDialog.score = "";
      this.editScoreDialog.showDialog = false;
    },
    /**
     * 跳转用户详情
     */
    toUserDetail(acId) {
      this.$router.push("/client_user/detail/" + acId);
    }
  }
};
</script>

<style lang="less">
.sticker-detail-wrap {
  min-height: calc(100vh - 60px);
  .sticker-detail-table {
    border-left: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    td,
    th {
      padding: 10px;
      border: 1px solid #ebeef5;
      border-left: none;
      border-bottom: none;
      font-size: 14px;
    }
    th {
      min-width: 140px;
      width: 5%;
      background-color: #f5f7fa;
      font-weight: normal;
    }
    td {
      width: 45%;
    }
    .delete-icon,
    .edit-icon {
      color: #000;
      font-size: 20px;
      vertical-align: middle;
    }
    .score-input {
      width: 200px;
    }
  }
  .edit-score-tips {
    position: relative;
    top: -20px;
  }
}
.opera-dialog {
  width: 400px;
}
</style>
